module.exports = __webpack_public_path__ + "static/media/90sMusicThumb.b6f0894e.jpg";